import { observer, inject } from 'mobx-react'

import { ActionMenu } from '../../../components'
import { withRouterProps } from '../../../utils'
import {
  SectionRow,
  SectionLabel,
  AccountNameLink,
  SectionSubLabel,
  NameField,
  BalanceField,
} from './DashboardStyle'

function DashboardStockOption(props) {
  const {
    navigate,
    store: {
      person: { displayName },
    },
  } = props

  const handleOpenStockOptions = () => {
    navigate('/accounts/stock-options')
  }

  return (
    <SectionRow id='dashboard-stock-options'>
      <NameField>
        <SectionLabel>
          <AccountNameLink type='button' onClick={handleOpenStockOptions}>
            Stock Options
          </AccountNameLink>
        </SectionLabel>
        <SectionSubLabel>{displayName}</SectionSubLabel>
      </NameField>
      <BalanceField>
        <ActionMenu
          items={[{ label: 'View', onClick: handleOpenStockOptions }]}
          ariaLabel='Actions for Stock Options'
        />
      </BalanceField>
    </SectionRow>
  )
}

export default withRouterProps(inject('store')(observer(DashboardStockOption)))
